import CenterContainer from './CenterContainer'

export default CenterContainer
